import { GridFooterActions, type GridFooterActionsProps } from './GridFooterActions';
import { GridFooterTotals, type GridFooterTotalsProps } from './GridFooterTotals';

export type TimesheetGridFooterProps = GridFooterActionsProps & GridFooterTotalsProps;

/** Sticky `<tfoot>` row: row actions on the left, daily and week totals on the right. */
export function TimesheetGridFooter({
  isReadOnly,
  enableCopyPreviousWeek,
  enableAutoSmartFill,
  onAddRow,
  onCopyLastWeek,
  onOpenAutoFill,
  ...totalsProps
}: TimesheetGridFooterProps) {
  return (
    <tfoot className="sticky bottom-0 z-10 bg-background">
      <tr className="border-t-2 bg-muted font-bold">
        <GridFooterActions
          isReadOnly={isReadOnly}
          enableCopyPreviousWeek={enableCopyPreviousWeek}
          enableAutoSmartFill={enableAutoSmartFill}
          onAddRow={onAddRow}
          onCopyLastWeek={onCopyLastWeek}
          onOpenAutoFill={onOpenAutoFill}
        />
        <GridFooterTotals {...totalsProps} />
      </tr>
    </tfoot>
  );
}
